import clsx from 'clsx'

import { scoreLevel } from '@/common/util/featureRewrite'

import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  breakdown: Record<string, number>
  labelMap?: Record<string, string>
}

const Bar = ({ label, value }: { label: string; value: number }) => {
  const level = scoreLevel(value)
  const fillClass =
    level === 'high' ? 'bg-fill-success' : level === 'mid' ? 'bg-yellow-300' : 'bg-fill-critical'
  const valueColor =
    level === 'high' ? TextColor.SUCCESS : level === 'mid' ? TextColor.CAUTION : TextColor.CRITICAL
  return (
    <div className='flex flex-col gap-1.5'>
      <Text size={12} weight='bold'>
        {label}
      </Text>
      <div className='flex items-center gap-2'>
        <div className='bg-fill-tertiary h-3 w-25 flex-1 rounded-full'>
          <div className={clsx('h-3 rounded-full', fillClass)} style={{ width: `${value}%` }} />
        </div>
        <div className='flex shrink-0 items-baseline justify-end gap-1'>
          <Text size={24} weight='bold' color={valueColor}>
            {value}
          </Text>
        </div>
      </div>
    </div>
  )
}

const ScoreBreakdownBars = ({ breakdown, labelMap }: Props) => {
  return (
    <div className='display flex items-center gap-5'>
      {Object.entries(breakdown).map(([key, value]) => (
        <Bar key={key} label={labelMap?.[key] ?? key} value={value} />
      ))}
    </div>
  )
}

export default ScoreBreakdownBars
